import { useLocalStore, useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import { ProductsProps } from '../types/ProductsProps';
import { useStoreFilterDefaults } from '../utils/hooks/useStoreFilterDefaults';
import ProductCardV2 from './ProductCardV2';
import { CartActionOption } from '../types/CartItemProps';

const UnstyledStoreProductsV2: React.FC<ProductsProps> = (props) => {
  useStoreFilterDefaults(props.defaultfilter, props.sort);

  const stateTree = useMst();
  const state = useLocalStore(() => ({
    get itemsBySection() {
      return stateTree.widgets.store.filteredProductsBySection;
    },
    get remainingItems() {
      //return sortProducts(Array.from(stateTree.widgets.store.filteredProductsWithoutSections), parseSortString(props.sort ?? ''));
      return stateTree.widgets.storeFilter.sortProducts(
        stateTree.widgets.store.filteredProductsWithoutSections.map((p) => p),
      );
    },
  }));

  return useObserver(() => (
    <div
      className={`ww-widget ww-store-products w-full ${props.className ?? ''}`}
    >
      {state.itemsBySection.length > 0 &&
        state.itemsBySection.flatMap((ibs) => (
          <>
            {!ibs.section.title || ibs.section.title.match(/^\s*$/g) ? (
              <React.Fragment key={ibs.section.productListId}></React.Fragment>
            ) : ibs.section.title === '-' ? (
              <hr key={`hr-${ibs.section.productListId}`} />
            ) : (
              <h2
                className="ww-section-title"
                key={`h2-${ibs.section.productListId}`}
              >
                {ibs.section.title}
              </h2>
            )}
            <div
              className="list"
              data-product-list-id={ibs.section.productListId}
              key={'s_' + ibs.section.productListId}
            >
              {ibs.products.map((p) => (
                <ProductCardV2
                  key={'s_' + ibs.section.productListId + '_p_' + p.id}
                  toasteroptions={props.toasteroptions ?? {}}
                  cartaction={
                    props.cartaction ?? CartActionOption.ShowNotifications
                  }
                  format="store"
                  product={{ id: p.id + '' }}
                  priceFormat={props.pricing}
                  enablevariations={props.enablevariations}
                />
              ))}
            </div>
          </>
        ))}
      {state.itemsBySection.length > 0 && state.remainingItems.length > 0 && (
        <hr />
      )}
      {state.remainingItems.length > 0 && (
        <div className="list">
          {state.remainingItems.map((item) => (
            <ProductCardV2
              cartaction={
                props.cartaction ?? CartActionOption.ShowNotifications
              }
              toasteroptions={props.toasteroptions ?? {}}
              format="store"
              key={'p_' + item.id}
              product={{ id: item.id + '' }}
              priceFormat={props.pricing}
              enablevariations={props.enablevariations}
            />
          ))}
        </div>
      )}
      {state.remainingItems.length === 0 &&
        state.itemsBySection.length === 0 && (
          <div className="p-20 text-center text-gray-400"></div>
        )}
    </div>
  ));
};

const StoreProductsV2 = styled(UnstyledStoreProductsV2)`
  width: 100%;

  .list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;
    gap: 1.538em;
  }
`;

export default StoreProductsV2;
